import { useEffect, useState } from 'react';
import { botVinculado, generarCodigoVinculacion } from '../../lib/api-config';
import { Boton, Tarjeta, TextoAyuda } from '../../ui/base';
import { instalacion } from '@tanteo/compartido/instalacion';

const BOT_USUARIO = instalacion.bot.usuario;

/** Vincular el chat de Telegram del negocio para recibir el cierre y consultar desde el bot. */
export function SeccionBot({ negocioId }: { negocioId: string }) {
  const [codigo, setCodigo] = useState('');
  const [vinculado, setVinculado] = useState<boolean | null>(null);
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    void botVinculado(negocioId).then(setVinculado);
  }, [negocioId]);

  return (
    <Tarjeta>
      <h2 className="mb-2 font-extrabold">Bot de Telegram</h2>
      {vinculado ? (
        <p className="text-success font-semibold">Este negocio ya tiene un chat vinculado. Comandos: /hoy · /cuadre · /existencias</p>
      ) : (
        <>
          <TextoAyuda>
            Recibe el cierre del día y consulta tus ventas desde Telegram. Genera un código, abre el bot y envíale
            <span className="num"> /vincular CODIGO</span>.
          </TextoAyuda>
          {codigo ? (
            <p className="num bg-primary/10 text-primary-deep rounded-control inline-block px-4 py-2 text-cifra font-extrabold tracking-widest">
              {codigo}
            </p>
          ) : (
            <Boton
              disabled={ocupado}
              onClick={() => {
                setOcupado(true);
                generarCodigoVinculacion(negocioId)
                  .then(setCodigo)
                  .finally(() => setOcupado(false));
              }}
            >
              Generar código de vinculación
            </Boton>
          )}
          <p className="text-muted mt-2 text-etiqueta">El código vence en 10 minutos. Bot: @{BOT_USUARIO}</p>
        </>
      )}
    </Tarjeta>
  );
}
